const AuthConstants = {
    CHANGE_THEME:        'CHANGE_THEME',
    LOGIN_SUCCESS:       'LOGIN_SUCCESS',
    LOGIN_FAILURE:       'LOGIN_FAILURE',
    CHECK_LOGIN_SUCCESS: 'CHECK_LOGIN_SUCCESS',
    USER_LOGIN_SUCCESS:  'USER_LOGIN_SUCCESS',
    LOGOUT:              'LOGOUT',
    REDIRECT_SCREEN:     'REDIRECT_SCREEN',
    SESSION_CHECKED:     'SESSION_CHECKED',
};

export default AuthConstants;
